/**
 * Workaround for emitting events from inside <component :is="" /> component wrapped by vuetify2 components
 */
export default {
  methods: {
    emitEvent(event, ...args) {
      if (this.$listeners[event]) {
        this.$listeners[event](...args);
      } else {
        this.$emit(event, ...args);
      }
    },
  },
};
